import React from 'react';
import { Input } from 'reactstrap';

const PositiveNumberInput = ({
    label,
    value,
    onChange,
    placeholder,
    required = false,
    step = 0.01,
    className = '',
    ...props
}) => {
    const handleChange = (e) => {
        let val = e.target.value;
        
        // Allow empty string for clearing
        if (val === '') {
            onChange(e);
            return;
        }

        // Convert to number
        const numVal = parseFloat(val);

        // Only allow non-negative values
        if (!isNaN(numVal) && numVal >= 0) {
            onChange(e);
        }
    };

    return (
        <Input
            type="number"
            min="0"
            step={step}
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            className={className}
            {...props}
        />
    );
};

export default PositiveNumberInput;
